<template>
  <ReplacementsComponent />
</template>

<script>
import ReplacementsComponent from "@/sections/voiceplus/components/ReplacementsComponent.vue";
import config from "@/config";

export default {
  name: "Replacements",
  components: { ReplacementsComponent },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
